import { resetMoneyEntriesFetch, setCancelOrderStatus } from "actions/balance";
import { fetchUser } from "actions/user";
import { put, takeLeading } from "redux-saga/effects";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { post } from "sagas/helpers/network";

function* execute(action: sage.actions.balance.ICancelOrder) {
    yield put(setCancelOrderStatus("loading", action.orderId));
    try {
        yield post("/cancel-order", {
            order_id: action.orderId,
        });
        yield put(setCancelOrderStatus("cancelled", action.orderId));
        yield put(fetchUser());
        yield put(resetMoneyEntriesFetch());
    } catch (e) {
        yield handleNetworkError(e);
        yield put(setCancelOrderStatus("error", action.orderId));
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.balance.ICancelOrder", execute);
}
